import 'bootstrap/js/dist/modal'

$('#scrollDown').on('click', function () {
    document.getElementById('cases').scrollIntoView({ block: "start", behavior: "smooth" });
})

$('#scrollUpMobile').on('click', function () {
    document.getElementById('topElement').scrollIntoView({ block: "start", behavior: "smooth" });
})

let lastScrollTop = 0;

function navbarChange() {
    var st = $(this).scrollTop();

    if (st > lastScrollTop && st > 33) {
        $('#preNav').addClass('scrolled-nav');
        $('#nav').addClass('scrolled-nav');
    } else {
        if (st === 0) {
            $('#preNav').removeClass('scrolled-nav');
            $('#nav').removeClass('scrolled-nav');
        }
    }

    lastScrollTop = st;
}

function enableNav() {
    let topPosition = document.getElementById('topElement').getBoundingClientRect().top;

    if (topPosition !== 0) {
        $('#nav').addClass('scrolled-nav');
        $('#preNav').addClass('scrolled-nav');
    }
    $(window).on('scroll', navbarChange);
}

if (window.innerWidth > 992) {
    enableNav();
}

const thumbsInit = () => {
    $(".scrollable-dropdown").each(function () {
        let $this = $(this);
        const $content = $(this).find('.content');
        const $scrollbar = $(this).find(".custom-scrollbar");
        const $thumb = $scrollbar.find(".scroll-thumb");
        const $scrolledArea = $scrollbar.find(".scrolled-area");

        const SCROLL_STEP = 50;

        const updateThumbAndScrolledArea = () => {
            const contentScrollHeight = $content[0].scrollHeight - $content.innerHeight();
            const scrollbarHeight = $scrollbar.height();
            const thumbHeight = $thumb.height();

            const scrollPercent = $content.scrollTop() / contentScrollHeight;

            const thumbTop = scrollPercent * (scrollbarHeight - thumbHeight);
            $thumb.css("top", thumbTop);

            $scrolledArea.css("height", thumbTop + thumbHeight / 2);
        };

        $content.on("scroll", updateThumbAndScrolledArea);

        // Up-scroll button click handler
        $(this).find(".up-scroll").on("click", function () {
            $content.scrollTop($content.scrollTop() - SCROLL_STEP);
        });

        // Down-scroll button click handler
        $(this).find(".down-scroll").on("click", function () {
            $content.scrollTop($content.scrollTop() + SCROLL_STEP);
        });

        $content.on("wheel", function (e) {
            e.preventDefault(); // Prevent default browser behavior

            const delta = e.originalEvent.deltaY; // Get scroll delta
            $content.scrollTop($content.scrollTop() + delta); // Scroll content
        });

        let isDragging = false;
        let startY, startTop;

        $thumb.on("mousedown", function (e) {
            isDragging = true;
            startY = e.clientY;
            startTop = parseInt($thumb.css("top"), 10);
            e.preventDefault();
        });

        $(document)
            .on("mousemove", function (e) {
                if (!isDragging) return;

                const dy = e.clientY - startY;
                const scrollbarHeight = $scrollbar.height();
                const thumbHeight = $thumb.height();
                const maxTop = scrollbarHeight - thumbHeight;

                // Clamp thumb position
                const newTop = Math.min(Math.max(0, startTop + dy), maxTop);
                $thumb.css("top", newTop);

                // Sync content scroll
                const contentScrollHeight = $content[0].scrollHeight - $content.innerHeight();
                const scrollPercent = newTop / maxTop;
                $content.scrollTop(scrollPercent * contentScrollHeight);

                // Update scrolled area height
                $scrolledArea.css("height", newTop + thumbHeight / 2);
            })
            .on("mouseup", function () {
                isDragging = false;
            });

        const updateThumbSize = () => {
            $this.show();
            const contentHeight = $content.innerHeight();
            const contentScrollHeight = $content[0].scrollHeight;

            const thumbHeight = Math.max(
                (contentHeight / contentScrollHeight) * $scrollbar.height(),
                30
            );
            $thumb.css("height", thumbHeight);
            if (thumbHeight < 115) {
                $this.find('.custom-scrollbar').hide();
                $this.find('.up-scroll').hide();
                $this.find('.down-scroll').hide();
            } else {
                $this.find('.custom-scrollbar').show();
                $this.find('.up-scroll').show();
                $this.find('.down-scroll').show();
            }

            $this.hide();

            updateThumbAndScrolledArea();
        };

        const filteredSpan = $content.find('p span').filter(function () {
            if ($(this).css('display') !== 'none') {
                return $(this);
            }
        })

        filteredSpan.last().addClass('last-item');

        if (filteredSpan.length < 2) {
            $scrollbar.hide();
            $(this).find(".up-scroll").hide();
            $(this).find(".down-scroll").hide();
        } else {
            $scrollbar.show();
            $(this).find(".up-scroll").show();
            $(this).find(".down-scroll").show();
        }

        $(window).on("resize", updateThumbSize);

        updateThumbSize();
    });
};

const popupthumbsInit = () => {
    $(".popup-content-scroll").each(function () {
        let $this = $(this);
        const $content = $this.find('.scroll-content');
        const $scrollbar = $this.find(".custom-scrollbar");
        const $thumb = $scrollbar.find(".scroll-thumb");
        const $scrolledArea = $scrollbar.find(".scrolled-area");

        const SCROLL_STEP = 50;

        const updateThumbAndScrolledArea = () => {
            const contentScrollHeight = $content[0].scrollHeight - $content.innerHeight();
            const scrollbarHeight = $scrollbar.height();
            const thumbHeight = $thumb.height();

            const scrollPercent = $content.scrollTop() / contentScrollHeight;

            const thumbTop = scrollPercent * (scrollbarHeight - thumbHeight);
            $thumb.css("top", thumbTop);

            $scrolledArea.css("height", thumbTop + thumbHeight / 2);
        };

        $content.on("scroll", updateThumbAndScrolledArea);

        // Up-scroll button click handler
        $(this).find(".up-scroll").on("click", function () {
            $content.scrollTop($content.scrollTop() - SCROLL_STEP);
        });

        // Down-scroll button click handler
        $(this).find(".down-scroll").on("click", function () {
            $content.scrollTop($content.scrollTop() + SCROLL_STEP);
        });

        $content.on("wheel", function (e) {
            e.preventDefault(); // Prevent default browser behavior

            const delta = e.originalEvent.deltaY; // Get scroll delta
            $content.scrollTop($content.scrollTop() + delta); // Scroll content
        });

        let isDragging = false;
        let startY, startTop;

        $thumb.on("mousedown", function (e) {
            isDragging = true;
            startY = e.clientY;
            startTop = parseInt($thumb.css("top"), 10);
            e.preventDefault();
        });

        $(document)
            .on("mousemove", function (e) {
                if (!isDragging) return;

                const dy = e.clientY - startY;
                const scrollbarHeight = $scrollbar.height();
                const thumbHeight = $thumb.height();
                const maxTop = scrollbarHeight - thumbHeight;

                // Clamp thumb position
                const newTop = Math.min(Math.max(0, startTop + dy), maxTop);
                $thumb.css("top", newTop);

                // Sync content scroll
                const contentScrollHeight = $content[0].scrollHeight - $content.innerHeight();
                const scrollPercent = newTop / maxTop;
                $content.scrollTop(scrollPercent * contentScrollHeight);

                // Update scrolled area height
                $scrolledArea.css("height", newTop + thumbHeight / 2);
            })
            .on("mouseup", function () {
                isDragging = false;
            });

        const updateThumbSize = () => {
            $this.show();
            const contentHeight = $content.innerHeight();
            const contentScrollHeight = $content[0].scrollHeight;

            const thumbHeight = Math.max(
                (contentHeight / contentScrollHeight) * $scrollbar.height(),
                30
            );
            $thumb.css("height", thumbHeight);
            if (thumbHeight < 115) {
                $this.find('.custom-scrollbar').hide();
                $this.find('.up-scroll').hide();
                $this.find('.down-scroll').hide();
            } else {
                $this.find('.custom-scrollbar').show();
                $this.find('.up-scroll').show();
                $this.find('.down-scroll').show();
            }

            // $this.hide();

            updateThumbAndScrolledArea();
        };

        const filteredSpan = $content.find('p span').filter(function () {
            if ($(this).css('display') !== 'none') {
                return $(this);
            }
        })

        filteredSpan.last().addClass('last-item');

        if (filteredSpan.length < 2) {
            $scrollbar.hide();
            $(this).find(".up-scroll").hide();
            $(this).find(".down-scroll").hide();
        } else {
            $scrollbar.show();
            $(this).find(".up-scroll").show();
            $(this).find(".down-scroll").show();
        }

        $(window).on("resize", updateThumbSize);

        updateThumbSize();
    });
};

function enableCookies () {

    const getCookie = function (cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };

    const setCookie = function (cname, cvalue, exdays) {
        let d, expires;
        d = new Date;
        d.setTime(d.getTime() + exdays * 1000 * 24 * 365 * 10);
        expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    };
    function allConsentGranted() {
        gtag('consent', 'update', {
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'ad_storage': 'granted',
            'analytics_storage': 'granted'
        });
    }

    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }

    if (getCookie('cookie_func') === 'false') {
        // finction cookie
    }
    if (getCookie('cookie_3rd_stat') === 'false' && getCookie('cookie_3rd_adv') === 'false') {
        // google
        gtag('set', 'allow_google_signals', false);
    }
    if (getCookie('cookie_3rd_adv') === 'false') {
        // google
        gtag('set', 'allow_ad_personalization_signals', false);

        // facebook
        // fbq('consent', 'revoke');
    }
    if (getCookie('cookie_3rd_adv') === 'true'){
        // fbq('consent', 'grant');
        gtag('set', 'allow_ad_personalization_signals', true);
        gtag('consent', 'update', {
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'ad_storage': 'granted',
        });
    }
    if (getCookie('cookie_notice_accepted') !== 'true') {
        // console.log(getCookie('cookie_notice_accepted'));
        $('#cookie-banner').removeClass('hidden-banner');
    }
    if (getCookie('cookie_3rd_stat') === 'true'){
        gtag('consent', 'update', {
            'analytics_storage': 'granted'
        });
    }
    $('#accept-cookies, .yes-to-all').on('click', function () {
        $('#func').prop('checked', true);
        $('#cookie_3rd_stat').prop('checked', true);
        $('#cookie_3rd_adv').prop('checked', true);
        setCookie("cookie_func", true, 30);
        setCookie("cookie_3rd_adv", true, 30);
        setCookie("cookie_3rd_stat", true, 30);
        setCookie("cookie_notice_accepted", true, 30)
        allConsentGranted();
        $('#cookie-banner').addClass('hidden-banner');
        $('#customize-cookies').fadeOut();
    })
    if (getCookie('cookie_notice_accepted') !== "true") {
        $('#cookie-notice').removeClass('hidden-notice');
    }
    $('#reject-cookies, .no-to-all').on('click', function () {
        $('#func').prop('checked', false);
        $('#cookie_3rd_stat').prop('checked', false);
        $('#cookie_3rd_adv').prop('checked', false);
        setCookie("cookie_func", false, 30);
        setCookie("cookie_3rd_adv", false, 30);
        setCookie("cookie_3rd_stat", false, 30);
        setCookie("cookie_notice_accepted", true, 30)
        $('#cookie-notice').addClass('hidden-notice');
        $('#customize-cookies').fadeOut();
        $('#cookie-banner').addClass('hidden-banner');
    });
    $('#eucookieform').on('submit', function (e){
        e.preventDefault();
        let cookie_func = $('#func').prop('checked');
        let cookie_3rd_stat = $('#cookie_3rd_stat').prop('checked');
        let cookie_3rd_adv = $('#cookie_3rd_adv').prop('checked');
        // console.error(cookie_3rd_stat, cookie_func, cookie_3rd_adv);
        setCookie("cookie_func", cookie_func, 30);
        setCookie("cookie_3rd_adv", cookie_3rd_adv, 30);
        setCookie("cookie_3rd_stat", cookie_3rd_stat, 30);
        setCookie("cookie_notice_accepted", true, 30)
        if (cookie_3rd_adv) {
            gtag('consent', 'update', {
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'ad_storage': 'granted',
            });
        }
        if (cookie_3rd_stat) {
            gtag('consent', 'update', {
                'analytics_storage': 'granted'
            });
        }
        $('#customize-cookies').fadeOut();
        setTimeout(function () {
            $('#cookie-banner').addClass('hidden-banner');
        }, 300)
    })
    $('#customize-cookies-btn').on('click', function () {
        $('#customize-cookies').fadeIn(200);
    })
    $('.eucookie_close').on('click', function (){
        $('#customize-cookies').fadeOut(200);
    })
    $('.close-cookies').on('click', function (e) {
        $('#cookie-banner').addClass('hidden-banner');
    })
}

$(document).on('click', function (e) {
    // let $target = $(e.target);
    // console.log($target);
    if ($('body').hasClass('modal-open')) {
        let $target = $(e.target);
        const $modals = $('.modal');
        let OnModalCheck = $target.closest('.modal-content').length > 0;
        let isCloseButton = $target.closest('.btn-close').length > 0;

        if (!OnModalCheck) {
            $modals.each(function (e) {
                $(this).modal('hide');
            })
        }

        if (isCloseButton) {
            $target.closest('.modal').modal('hide');
        }
    }
})

$(document).ready(function () {
    const $mobileMenuToggle = $('#mobile_menu_toggle');
    const $mobileMenu = $('#mobile-menu');
    const $dropdownSelects = $('.dropdown-select');
    const $wpcf7 = $('.wpcf7');
    const $aboutModalBtn = $('a[href="#ApieGydytoja"]');
    const $aboutModal = $('#doctor-modal');
    const $faqItems = $('.faq-item');
    const $prenavItems = $('.prenav-item');
    const $submitBtns = $('.wpcf7 button.btn-default');
    const $expandMapBtn = $('.expand-map');
    const $servicesBtn = $('#more-services-btn');

    $expandMapBtn.on('click', function () {
        $(this).toggleClass('expanded');
    })

    thumbsInit();
    enableCookies();
    // popupthumbsInit();

    $('input#acceptance').on('change', function () {
        let hiddenInput = $('input[name=acceptance-hidden]');

        if ($(this).is(':checked')) {
            hiddenInput.val('Duotas');
        } else {
            hiddenInput.val('Neduotas');
        }
    })

    let toggled = false;
    $servicesBtn.on('click', function (e) {
        $('.service-block').toggle();

        if (toggled) {
            $(this).text('Daugiau paslaugų');
            toggled = false;
        } else {
            toggled = true;
            $(this).text('Mažiau paslaugų');
        }
    })

    document.addEventListener('wpcf7mailsent', function (event) {
        const inputsData = {};

        for (let item of event.detail.inputs) {
            inputsData[item.name] = item.value;
        }

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'GET',
            data: {
                action: 'send_registration_mail',
                inputsData
            },
            success: function (response) {
                console.log(response.success);
            }
        })
    })

    $submitBtns.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const $form = $(e.target).closest('form');
        const form = $form[0];

        let check = true;

        if ($form.hasClass('wpcf7-form')) {
            const $formAcceptance = $form.find('.input-field.acceptance');
            const $inputFields = $form.find('.input-field .wpcf7-form-control-wrap:has(.wpcf7-validates-as-required)')
            const $selectFields = $form.find('.input-field.select');

            $inputFields.each(function () {
                let $this = $(this);
                let $input = $this.find('input');
                if ($input.length < 1) {
                    $input = $this.find('textarea');
                }
                let $inputValue = $input.val() === '';

                $this.find('.wpcf7-not-valid-tip').remove();
                if ($inputValue) {
                    const notValidTip = `<span class="wpcf7-not-valid-tip" aria-hidden="true">Prašome užpildyti šį laukelį</span>`;
                    $this.append(notValidTip);
                    $input.addClass('wpcf7-not-valid')
                    check = false;
                } else {
                    $input.removeClass('wpcf7-not-valid')
                }
            })

            $selectFields.each(function () {
                let $this = $(this);

                let dropdownSelect = $this.find('.dropdown-select');
                let inputField = dropdownSelect.find('> div:first-child');
                let hiddenInputValue = $this.find('.wpcf7-form-control.wpcf7-hidden').attr('value');

                if (hiddenInputValue === '') {
                    $this.find('.wpcf7-not-valid-tip').remove();
                    const notValidTip = `<span class="wpcf7-not-valid-tip" aria-hidden="true">Prašome užpildyti šį laukelį</span>`;

                    inputField.addClass('wpcf7-not-valid');
                    $this.append(notValidTip);
                    check = false;
                } else {
                    $this.find('.wpcf7-not-valid-tip').remove();
                    inputField.removeClass('wpcf7-not-valid');
                }
            })

            if (!$formAcceptance.find('input').prop('checked')) {
                const notValidTipAcceptance = `<span class="wpcf7-not-valid-tip" aria-hidden="true">Prašome sutikti su privatumo politika</span>`;

                if ($('.input-field.acceptance .wpcf7-not-valid-tip').length === 0) {
                    $formAcceptance.find('label').addClass('wpcf7-not-valid');
                    $('.input-field.acceptance').append(notValidTipAcceptance);
                }
                check = false;
            } else {
                $formAcceptance.find('label').removeClass('wpcf7-not-valid');
                $('.input-field.acceptance').find('.wpcf7-not-valid-tip').remove();
            }

            if (check) {
                form.dispatchEvent(new Event('submit', {'cancelable': true, 'bubbles': true}));
            }
        } else {
            form.dispatchEvent(new Event('submit', {'cancelable': true, 'bubbles': true}));
        }

    })

    $prenavItems.each(function () {
        const $this = $(this);
        let $anchor = $this.find('.prenav-item-content a');
        let href = $anchor.attr('href');

        if (href?.includes('mailto:')) {
            $this.find('.img-a').attr('href', href);
        }
    })

    $faqItems.on('click', function () {
        const $this = $(this);
        const $hiddenContent = $this.find('.hidden-content');

        if ($this.hasClass('showing')) {
            $this.removeClass('showing');
            $hiddenContent.slideUp();
        } else {
            $faqItems.removeClass('showing');
            $('.hidden-content').slideUp();
            $this.addClass('showing');
            $hiddenContent.slideDown();
        }
    })

    $('a[href*="#"]').on('click', function (e) {
        const href = $(this).attr('href');
        console.log('dasss')
        // if (href.includes('/#Registracija')) {
        //     window.location = href;
        // }
        const targetID = href.split('#')[1];
        const $target = $(`#${targetID}`);
        const dataTarget = $(this).data('target') !== undefined;
        const excludedStrings = ['Apie', 'Registracija', 'ApieGydytoja'];

        if ($target && !dataTarget && !excludedStrings.includes(targetID)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const headerOffset = window.innerWidth > 991 ? 160 : 100;
            const elementPosition = $target[0].getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            })
        } else if (targetID === 'Registracija' || targetID === 'Apie') {
            if ($(`#${targetID}`).length > 0) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                const headerOffset = window.innerWidth > 991 ? 160 : 100;
                const elementPosition = $target[0].getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                })
            }
        }
    })

    $aboutModalBtn.on('click', function (e) {
        e.preventDefault();
        if ($('body').hasClass('modal-open')) {
            setTimeout(function () {
                $aboutModal.modal('show');
            }, 100)
        } else {
            $aboutModal.modal('show');
        }
        setTimeout(function () {
            popupthumbsInit();
        }, 150)
    })

    $mobileMenuToggle.on('click', function () {
        $mobileMenu.toggleClass('toggled');
        $(this).toggleClass('toggled');
    })

    if ($dropdownSelects[0] !== undefined) {
        $dropdownSelects.each(function () {
            let $this = $(this);
            const $hiddenDropdown = $this.find('.hidden-dropdown.scrollable-dropdown');
            const $selectDropdown = $hiddenDropdown.find('span');
            const $svg = $(this).find('svg').first();

            $this.on('click', function (e) {
                if ($hiddenDropdown.is(':visible')) {
                    $hiddenDropdown.css('display', 'none');
                    $svg.removeClass('rotate-180');
                } else {
                    $hiddenDropdown.css('display', 'flex');
                    $svg.addClass('rotate-180');
                }
            })

            $hiddenDropdown.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
            })

            $selectDropdown.on('click', function (e) {
                let $this = $(this);
                if ($this.hasClass('with-link')) {
                    window.location = $this.find('a').attr('href');
                } if ($this.closest('.sub-cat').length > 0) {
                    e.stopPropagation();
                    window.location = $this.find('.sub-cat a').attr('href');
                } else {
                    e.preventDefault();
                    e.stopPropagation();
                    const $parent = $(this).closest('.dropdown-select');
                    const $parentDiv = $parent.find('> div:first-child');
                    const $parentSelectedItem = $parent.find('.selected-item');
                    const $parentInput = $(this).closest('.input-field.select').find('input.select-input');
                    const $thisText = $(this).data('select');
                    let subService = $(`span[data-belongs="${$thisText}"]`);

                    if ($this.closest('.sub-service').length < 1) {
                        $('.input-field.select:has(.sub-service)').removeClass('single');
                    }
                    if ($this.closest('.wpcf7').length > 0 && $this.closest('.sub-service').length < 1 && subService.length === 1) {
                        $('.input-field.select:has(.sub-service)').addClass('single');

                        setTimeout(function () {
                            subService.click();
                        }, 125)
                    }

                    $parent.closest('.input-field.select').find('.wpcf7-not-valid-tip').remove();
                    $parentDiv.removeClass('wpcf7-not-valid')
                    $parentInput.attr('value', $thisText);
                    $parentSelectedItem.text($thisText);

                    $hiddenDropdown.css('display', 'none');
                    $svg.removeClass('rotate-180');
                }
            })
        })

        $dropdownSelects.each(function (e) {
            const $svg = $(this).find('svg');

            $svg.removeClass('rotate-180');
        })

        let $servicesDropdownItems = $('.scrollable-dropdown.services span[data-select]');
        let $subServicesDropdownItems = $('.scrollable-dropdown.sub-service span[data-select]')
        let $subServices = $subServicesDropdownItems.closest('.input-field.select');
        let $selectedItem = $subServices.find('.selected-item');
        let placeholder = $selectedItem.data('placeholder');
        let $subServiceInput = $subServices.find('.select-input');

        $servicesDropdownItems.on('click', function (e) {
            let selector = $(this).text();

            $selectedItem.text(placeholder);
            $subServiceInput.val('');

            if (!($selectedItem.css('opacity') === '0') && (!$('.input-field.select:has(.sub-service)').hasClass('single'))) {
                $subServices.addClass('shown');
            } else {
                $subServices.removeClass('shown');
            }

            $subServicesDropdownItems.show();
            const filteredItems = $subServicesDropdownItems.filter(function () {
                if ($(this).data('belongs') === selector) {
                    return $(this);
                }
            })

            $subServicesDropdownItems.hide();
            filteredItems.show();

            thumbsInit();
        })
    }

    if ($wpcf7[0] !== undefined) {
        const fileInput = $('#file-upload');
        const fileNameDisplay = $('#file-upload-filename');

        fileInput.on('change', function () {
            const filename = this.files[0] ? this.files[0].name : 'No file chosen';
            fileNameDisplay.text(filename);
        });

        const $telInput = $('.allow-number input');
        const $codeInput = $('.allow-number-code input');

        $telInput.on('keypress', function (e) {
            const charCode = (e.which) ? e.which : e.keyCode;
            const charStr = String.fromCharCode(charCode);

            if (!/[\d+\-()\s]/.test(charStr)) {
                e.preventDefault();
            }
        });

        $codeInput.on('keypress', function (e) {
            const charCode = (e.which) ? e.which : e.keyCode;
            const charStr = String.fromCharCode(charCode);

            if (!/[\d]/.test(charStr)) {
                e.preventDefault();
            }
        });
    }

    $.scrollUp({
            animation: 'fade',
            activeOverlay: '#00FFFF',
            scrollText: `
                <svg id="arrow_scroll_up-01" class="fill-[#7E684D]" xmlns="http://www.w3.org/2000/svg" width="32.148" height="30.052" viewBox="0 0 32.148 30.052">
                  <path id="Path_194" class="fill-[#7E684D]" data-name="Path 194" d="M1.747,17.821A1.586,1.586,0,0,0,2.97,17.3l13.1-13.1,13.1,13.1a1.689,1.689,0,0,0,2.446,0,1.689,1.689,0,0,0,0-2.446L17.472.524A1.984,1.984,0,0,0,16.074,0a1.887,1.887,0,0,0-1.223.524L.524,14.851a1.689,1.689,0,0,0,0,2.446A1.586,1.586,0,0,0,1.747,17.821Z" transform="translate(0 0)" fill="#09a4b6"/>
                  <path id="Path_195" class="fill-[#7E684D]" data-name="Path 195" d="M17.472,7.524A1.984,1.984,0,0,0,16.074,7a1.887,1.887,0,0,0-1.223.524L.524,21.851a1.689,1.689,0,0,0,0,2.446,1.887,1.887,0,0,0,1.223.524A1.887,1.887,0,0,0,2.97,24.3l13.1-13.1,13.1,13.1a1.689,1.689,0,0,0,2.446,0,1.689,1.689,0,0,0,0-2.446Z" transform="translate(0 5.23)" fill="#09a4b6"/>
                </svg>`
        }
    );
})